import React, { useState } from 'react';
import axios from 'axios';

const ContactForm = ({ organisation }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/contact`, {
        ...formData,
        organisationId: organisation?.id
      });
      setStatus('success');
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      setStatus('error');
    }
  };

  const inputStyle = "mt-1 block w-full rounded-md shadow-sm focus:ring-2 focus:ring-purple-400 focus:border-purple-400 bg-[rgba(30,11,56,0.6)] border border-[rgba(139,118,227,0.4)] text-white py-2.5 px-3";

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label htmlFor="name" className="block text-sm font-medium text-white">Name</label>
        <input
          type="text"
          id="name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          className={inputStyle}
          required
        />
      </div>

      <div>
        <label htmlFor="email" className="block text-sm font-medium text-white">Email</label>
        <input
          type="email"
          id="email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          className={inputStyle}
          required
        />
      </div>

      <div>
        <label htmlFor="phone" className="block text-sm font-medium text-white">Phone (optional)</label>
        <input
          type="tel"
          id="phone"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          className={inputStyle}
        />
      </div>

      <div>
        <label htmlFor="message" className="block text-sm font-medium text-white">Message</label>
        <textarea
          id="message"
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
          rows={4}
          className={inputStyle}
          required
        />
      </div>

      <button
        type="submit"
        disabled={status === 'sending'}
        className="w-full text-white py-3 px-4 rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-400 hover:opacity-90"
        style={{background: 'linear-gradient(180deg, #301555 0%, #411C73 50%, #1E0B38 100%)', border: '1px solid rgba(255,255,255,0.2)'}}
      >
        {status === 'sending' ? 'Sending...' : 'Send Message'}
      </button>

      {status === 'success' && (
        <p className="text-green-400">Message sent successfully!</p>
      )}
      {status === 'error' && (
        <p className="text-red-400">Failed to send message. Please try again.</p>
      )}
    </form>
  );
};

export default ContactForm; 